import { OrdersDiscountAmounts_GroupedDiscountAmount, SvcPrefigureDiscounts } from "@springtree/eva-services-core";
import { useQuery } from "@tanstack/react-query";

import { useConfiguration } from "~/contexts/configuration";
import { useCart } from "~/hooks/use-cart";
import { useEvaService } from "~/hooks/use-eva-service";
import intlUtils from "~/utils/intl-utils";

import styles from "./discount-lines-totals.module.scss";

type Props = {
  lines: OrdersDiscountAmounts_GroupedDiscountAmount[];
  orderId?: string;
  currency?: string;
};

export default function DiscountLinesTotals(props: Props) {
  const priceFormatter = intlUtils.usePriceFormatter();
  const { configuration } = useConfiguration();
  const currency = props.currency ?? configuration?.CurrencyID;
  const cart = useCart();

  const evaServicePrefigureDiscounts = useEvaService(SvcPrefigureDiscounts);

  const { data: prefiguredDiscounts } = useQuery({
    queryKey: ["prefiguredDiscounts", props.orderId],
    staleTime: Infinity,
    queryFn: async () => {
      return await evaServicePrefigureDiscounts({ OrderID: props.orderId });
    },
    enabled: !!props.orderId,
  });

  const discountLines = props.lines.map((discount) => {
    const prefigureDiscountResult = props.orderId
      ? prefiguredDiscounts?.Results
      : cart?.AdditionalOrderData?.PrefiguredDiscounts;

    const promoLabelLocalized =
      prefigureDiscountResult && prefigureDiscountResult.length > 0
        ? prefigureDiscountResult.find((prefiguredDiscount) => prefiguredDiscount.DiscountID === discount.DiscountID)
            ?.MarketingDescription
        : undefined;

    return {
      discount: discount,
      description: promoLabelLocalized || discount.Discount?.Description,
    };
  });

  return (
    <>
      {discountLines.map((line) => (
        <div key={line.discount.DiscountID} className={styles.row}>
          <p className={styles.rowTitle}>{line.description}</p>
          <p className={styles.rowValue}>{priceFormatter.currency(line.discount.Total, { currency })}</p>
        </div>
      ))}
    </>
  );
}
